import type { Person } from './tree'

// What a quick add from someone's page says, for them or for you on your own page.
export function addForLabels(person: Pick<Person, 'name' | 'self' | 'living'>) {
  const { name, self } = person
  return {
    menu: self ? 'Add to your page' : `Add to ${name}’s page`,
    photos: self ? 'Add photos of you' : `Add photos of ${name}`,
    moment: self
      ? 'Write a moment you’re in'
      : person.living
        ? `Write a moment with ${name}`
        : `Write a memory of ${name}`,
    scan: self ? 'Scan your recipe card' : `Scan ${name}’s recipe card`,
    write: self ? 'Write out your recipe' : `Write out ${name}’s recipe`,
    tagged: self ? 'you' : name,
  }
}
